import React, { useEffect, useState } from "react";
import axios from 'axios'; // Import Axios
import { useParams } from "react-router-dom"; // Import useParams to access URL parameters
import Header from "../../common/header";
import Footer from "../../common/footer";
import { useLocation } from 'react-router-dom'; // Import useLocation to access query parameters


function Teamdetails() {
    const location = useLocation(); // Get the location object
    const query = new URLSearchParams(location.search); // Parse the query parameters
    const Id = query.get('id');
  const [member, setMember] = useState(null); // State to hold the team member details
  const [error, setError] = useState(null); // State to hold error messages

  useEffect(() => {
    const fetchMemberDetails = async () => {
      try {
        console.log("Fetching member details for ID:", Id); // Log the member ID
        const response = await axios.get(`https://tita.itrain.io/team/getTeam/${Id}`); // Fetch team member details from API
        console.log("Fetched member data:", response.data); // Log the fetched data
        if (response.data && response.data.success) {
          setMember(response.data.data); // Set the member state with the member details
        } else {
          setError("Failed to fetch member details. Please try again later."); // Handle case where success is false
        }
      } catch (error) {
        console.error("Error fetching member details:", error.response ? error.response.data : error.message); // Log detailed error
        setError("Failed to fetch member details. Please try again later."); // Set error message
      }
    };

    fetchMemberDetails();
  }, [Id]);

  if (error) {
    return <div className="error-message">{error}</div>; // Display error message if there is an error
  }

  if (!member) {
    return <div></div>; // Display loading message while fetching member details
  }

  return (
    <>
      <Header />
      <section className="team-details padding">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 sm-padding">
              <div className="team-details-thumb">
                <img src={member.Image} alt="thumb" />
                <div className="info-content">
                  <i className="fa-solid fa-chalkboard-teacher" />
                  <h3>{member.ExperienceNo}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-6 sm-padding">
              <div className="section-heading mb-30">
                <h2>{member.Name}</h2>
                <p><strong>Position:</strong> {member.Position}</p>
                <p><strong>Experience:</strong> {member.Experience}</p>
                <p><strong>Key Responsibilities:</strong> {member.Key_responsibilities}</p>
                <p><strong>Specialization:</strong> {member.Specialization}</p>
                <p><strong>Vision:</strong> {member.Vision}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Teamdetails;
